<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'" class="component-wrapper">
    <app-sas-management-login class="component"></app-sas-management-login>
  </div>

  <div *ngIf="page === 'register'" class="component-wrapper">
    <app-sas-management-register class="component"></app-sas-management-register>
  </div>

  <div *ngIf="page === 'forgot-password'" class="component-wrapper">
    <app-sas-management-forgot-password class="component"></app-sas-management-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'" class="component-wrapper">
    <app-sas-management-change-password-sent class="component"></app-sas-management-change-password-sent>
  </div>

  <div class="component-wrapper">
    <app-sas-management-register-resend
      *ngIf="page === 'register-resend'"
    ></app-sas-management-register-resend>
  </div>
</ng-container>
